import React from 'react';
import { NewsCard } from './NewsCard';
import { newsData } from '../data/newsData';
interface NewsListProps {
  category?: string;
  limit?: number;
}
export const NewsList = ({
  category,
  limit = 4
}: NewsListProps) => {
  const filteredNews = category ? newsData.filter(item => item.category === category).slice(0, limit) : newsData.slice(0, limit);
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-193">
      {filteredNews.map((news, index) => <NewsCard key={index} title={news.title} excerpt={news.excerpt} imageUrl={news.imageUrl} author={news.author} date={news.date} category={news.category} data-id="element-194" />)}
    </div>;
};